import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from '../Manager/Page/Home.js';
import Lead from './Page/Lead.js';
import SellProducts from './Page/Products/SellProducts.js';
import SellNewProducts from './Page/Products/new/SellNewProducts.js';
import SellProduct from './Page/Products/new/sellProduct.jsx';
import SellProductsOld from './Page/Products/old/sellProductOld.jsx';
import CalculateOrderCost from './CalculateOrderCost/Main.jsx'
import CalculateOrderCostEdit from './CalculateOrderCost/Edit/Main.jsx'

function NavbarManager(props) {

  return (
    <div>
      <Routes>
        <Route path="/*" element={<HomePage jwt={props.jwt} />} />
        {/* <Route path='/sellProduct' element={<SellProductsOld jwt={props.jwt} />} />
        <Route path='/sellProduct/new' element={<SellProducts jwt={props.jwt} />} /> */}
        <Route path='/sellProductEditor' element={<SellNewProducts jwt={props.jwt} />} />
        <Route path='/sellProduct/2026' element={<SellProduct jwt={props.jwt} />} />
        {/* <Route path='/lead' element={<Lead />} /> */}

        <Route path='/calculateOrderCost'>
          <Route path='' element={<CalculateOrderCost jwt={props.jwt} />} />
          <Route path='edit' element={<CalculateOrderCostEdit jwt={props.jwt} />} />
        </Route>
      </Routes>
    </div>
  );
}

export default NavbarManager;